import { createContext, useContext, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("agp_user")); } catch { return null; }
  });

  const login = useCallback(async (email) => {
    const { data } = await api.post("/auth/login", { email });
    localStorage.setItem("agp_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("agp_user");
    setUser(null);
  }, []);

  const role = user?.role;
  const can = {
    edit: role === "admin" || role === "evaluador",
    vote: role === "comite" || role === "admin",
    admin: role === "admin",
    tasks: role !== "lector",
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
